import { render, staticRenderFns } from "./MensagemVerifica.vue?vue&type=template&id=cc844d80&"
import script from "./MensagemVerifica.vue?vue&type=script&lang=js&"
export * from "./MensagemVerifica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports